// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"495":"be90ecf3","591":"933e88c0"}[chunkId] + ".chunk.js";
};